const DEFAULT_FONT = `IBMPlexSans`;
export const LumaFont = {
  DEFAULT: {
    THIN: `${DEFAULT_FONT}Thin`,
    LIGHT: `${DEFAULT_FONT}Light`,
    REGULAR: `${DEFAULT_FONT}Regular`,
    MEDIUM: `${DEFAULT_FONT}Medium`,
    SEMI_BOLD: `${DEFAULT_FONT}SemiBold`,
    BOLD: `${DEFAULT_FONT}Bold`,
  },
};
